import { create } from '@theme/create';

export const themed = create(
  new (function StickyMobileAddToCartTheme() {
    this.wrapper = {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 20, // Below all popups (modals: 40+, sidebars: 50+, header: 30+)
      bg: 'background',
      borderTop: (t) => `1px solid ${t.colors.gray}`,
      display: ['block', 'none'], // Only show on mobile
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
      transform: 'translateY(0)',
      transition: 'transform 0.3s ease-in-out',
    };

    this.content = {
      alignItems: 'center',
      justifyContent: 'center',
      px: 4,
      py: 3,
      maxWidth: '100vw',
      gap: 3,
    };

    this.button = {
      flex: 1,
      height: '44px',
      fontSize: '14px',
      fontWeight: 'bold',
      borderRadius: '22px',
      border: 'none',
      transition: 'all 0.2s ease',
      mx: 2,

      available: {
        bg: 'black',
        color: 'white',
        ':hover': {
          bg: 'mediumDarkGray',
        },
      },

      unavailable: {
        bg: 'gray',
        color: 'mediumGray',
        ':hover': {
          bg: 'gray',
          color: 'mediumGray',
        },
      },
    };

    // Import quantity selector styles from AddToCart theme
    this.quantityWrapper = {
      variant: 'flex.row.start.center',
      mr: 0,
      'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      'input[type=number]': {
        MozAppearance: 'textfield',
      },
    };

    this.quantityButton = {
      cursor: 'pointer',
      width: '32px',
      height: '32px',
      minWidth: '32px',
      borderRadius: '50%',
      border: (t) => `1px solid ${t.colors.gray}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'all 0.15s ease-in-out',
      ':hover': {
        borderColor: 'mediumDarkGray',
      },
    };

    this.buttonIcon = {
      width: '16px',
      color: 'text',
    };

    this.quantity = {
      variant: 'text.label.1',
      width: '34px',
      textAlign: 'center',
      mx: 5,
    };
  })()
);
